var _path, _path2, _rect, _rect2, _rect3, _g, _rect4, _path3, _path4, _rect5, _rect6, _g2, _rect7, _path5, _rect8, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterDatasetNoVariables = function SvgFilterDatasetNoVariables(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 84C56.2288 84 49.5 77.2712 49.5 69C49.5 60.7288 56.2288 54 64.5 54C72.7712 54 79.5 60.7288 79.5 69C79.5 77.2712 72.7712 84 64.5 84Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4489 73.9497L64.4991 69L59.5494 64.0503M59.5494 73.9497L69.4489 64.0503",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#9CA3AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9695_420217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 6,
    height: 5
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 5,
    height: 5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9695_420217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99945 6.72095L5.94255 7.77784C5.91371 7.80669 5.87745 7.82144 5.83378 7.82211C5.79011 7.82278 5.75319 7.80802 5.72301 7.77784C5.69283 7.74766 5.67773 7.71107 5.67773 7.66807C5.67773 7.62507 5.69283 7.58848 5.72301 7.5583L6.7799 6.5014L5.72301 5.44451C5.69416 5.41566 5.67941 5.3794 5.67874 5.33573C5.67807 5.29207 5.69283 5.25514 5.72301 5.22496C5.75319 5.19478 5.78978 5.17969 5.83278 5.17969C5.87578 5.17969 5.91237 5.19478 5.94255 5.22496L6.99945 6.28185L8.05634 5.22496C8.08519 5.19612 8.12144 5.18136 8.16511 5.18069C8.20878 5.18002 8.2457 5.19478 8.27589 5.22496C8.30607 5.25514 8.32116 5.29173 8.32116 5.33473C8.32116 5.37773 8.30607 5.41432 8.27589 5.44451L7.21899 6.5014L8.27589 7.5583C8.30473 7.58714 8.31949 7.6234 8.32016 7.66707C8.32083 7.71073 8.30607 7.74766 8.27589 7.77784C8.2457 7.80802 8.20911 7.82311 8.16611 7.82311C8.12311 7.82311 8.08652 7.80802 8.05634 7.77784L6.99945 6.72095Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 18,
    width: 64,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28C8.933 28 10.5 26.433 10.5 24.5C10.5 22.567 8.933 21 7 21C5.067 21 3.5 22.567 3.5 24.5C3.5 26.433 5.067 28 7 28Z",
    fill: "#6366F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52734 24.4071L6.72393 25.4795L8.60912 23.3008",
    stroke: "white",
    strokeWidth: 0.54341,
    strokeMiterlimit: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 21,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#9CA3AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9695_420217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 22,
    width: 6,
    height: 5
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 22,
    width: 5,
    height: 5,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9695_420217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99945 24.7209L5.94255 25.7778C5.91371 25.8067 5.87745 25.8214 5.83378 25.8221C5.79011 25.8228 5.75319 25.808 5.72301 25.7778C5.69283 25.7477 5.67773 25.7111 5.67773 25.6681C5.67773 25.6251 5.69283 25.5885 5.72301 25.5583L6.7799 24.5014L5.72301 23.4445C5.69416 23.4157 5.67941 23.3794 5.67874 23.3357C5.67807 23.2921 5.69283 23.2551 5.72301 23.225C5.75319 23.1948 5.78978 23.1797 5.83278 23.1797C5.87578 23.1797 5.91237 23.1948 5.94255 23.225L6.99945 24.2819L8.05634 23.225C8.08519 23.1961 8.12144 23.1814 8.16511 23.1807C8.20878 23.18 8.2457 23.1948 8.27589 23.225C8.30607 23.2551 8.32116 23.2917 8.32116 23.3347C8.32116 23.3777 8.30607 23.4143 8.27589 23.4445L7.21899 24.5014L8.27589 25.5583C8.30473 25.5871 8.31949 25.6234 8.32016 25.6671C8.32083 25.7107 8.30607 25.7477 8.27589 25.7778C8.2457 25.808 8.20911 25.8231 8.16611 25.8231C8.12311 25.8231 8.08652 25.808 8.05634 25.7778L6.99945 24.7209Z",
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 36,
    width: 64,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 44C7.82843 44 8.5 43.3284 8.5 42.5C8.5 41.6716 7.82843 41 7 41C6.17157 41 5.5 41.6716 5.5 42.5C5.5 43.3284 6.17157 44 7 44Z",
    fill: "#9CA3AF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 54,
    width: 44,
    height: 13,
    rx: 4,
    fill: "#E7E8E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 62C7.82843 62 8.5 61.3284 8.5 60.5C8.5 59.6716 7.82843 59 7 59C6.17157 59 5.5 59.6716 5.5 60.5C5.5 61.3284 6.17157 62 7 62Z",
    fill: "#9CA3AF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterDatasetNoVariables);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "filter-dataset-no-variables.d880d2fda9a5720c051e5ea82c6a0c4e.svg";